import React from "react";
import AnchorButton from "components/AnchorButton"
import { closeIcon } from "components/Icons"

const formatLineTotal = (quantity, unitAmount) => (
  (Math.round(quantity * unitAmount * 100) / 100).toFixed(2)
)

const InvoiceLineItems = ({
  invoiceLineItems, setInvoiceLineItems
}) => (
  <div className="invoice-line-items">
    <div className="invoice-line-items__title">
      <h5>Invoice Line Items</h5>
    </div>
    <div className="invoice-line-items__table-header">
      <div className="invoice-line-items__col--description">
        <h6>Description</h6>
      </div>
      <div className="invoice-line-items__col--meta">
        <h6 className="text-center">Qty</h6>
        <h6 className="text-center">Unit Price</h6>
        <h6 className="text-right">Total</h6>
        <span aria-hidden="true" />
      </div>
    </div>
    <hr className="mt-1 mb-2" />
    <div className="invoice-line-items__list">
      {invoiceLineItems.map(item => (
        <div className="invoice-line-item" key={item.id}>
          <div className="invoice-line-item__description">
            <label className="invoice-line-item__label" htmlFor={`invoice-line-desc-${item.id}`}>
              Description
            </label>
            <textarea
              id={`invoice-line-desc-${item.id}`}
              rows={2}
              value={item.description}
              onChange={e => setInvoiceLineItems(invoiceLineItems.map(li => (
                li.id === item.id ? { ...li, description: e.target.value } : li
              )))}
              className="form-control"
            />
          </div>
          <div className="invoice-line-item__meta">
            <div className="invoice-line-item__field invoice-line-item__field--qty">
              <label className="invoice-line-item__label" htmlFor={`invoice-line-qty-${item.id}`}>
                Qty
              </label>
              <input
                id={`invoice-line-qty-${item.id}`}
                min={0}
                step={1}
                value={item.quantity}
                onChange={e => setInvoiceLineItems(invoiceLineItems.map(li => (
                  li.id === item.id ? { ...li, quantity: Number(e.target.value || 0) } : li
                )))}
                className="form-control"
                type="number"
              />
            </div>
            <div className="invoice-line-item__field invoice-line-item__field--price">
              <label className="invoice-line-item__label" htmlFor={`invoice-line-price-${item.id}`}>
                Unit Price
              </label>
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">$</span>
                </div>
                <input
                  id={`invoice-line-price-${item.id}`}
                  min={0}
                  step={0.01}
                  value={item.unit_amount}
                  onChange={e => setInvoiceLineItems(invoiceLineItems.map(li => (
                    li.id === item.id ? { ...li, unit_amount: Number(e.target.value || 0) } : li
                  )))}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
            <div className="invoice-line-item__field invoice-line-item__field--total">
              <span className="invoice-line-item__label">Total</span>
              <div className="invoice-line-item__total-value">
                ${formatLineTotal(item.quantity, item.unit_amount)}
              </div>
            </div>
            <div className="invoice-line-item__field invoice-line-item__field--remove">
              {!item.disable_remove && (
                <AnchorButton
                  className="invoice-line-item__remove-btn"
                  onClick={() => {
                    setInvoiceLineItems(invoiceLineItems.filter(li => li.id !== item.id))
                  }}
                  aria-label="Remove line item">
                  <img src={closeIcon} alt="" />
                </AnchorButton>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
    {invoiceLineItems.length > 0 && (<hr className="mt-2 mb-1" />)}
    <div className="invoice-line-items__actions">
      <button
        className="btn btn-outlined-blue"
        onClick={() => setInvoiceLineItems([...invoiceLineItems, {
          id: Date.now(), description: "", quantity: 0, unit_amount: 0, item_type: "OTHER_FEE"
        }])}
        type="button">
        + Add Line Item
      </button>
    </div>
  </div>
)

export default InvoiceLineItems
